import { render, staticRenderFns } from "./SingleImage4.vue?vue&type=template&id=4fcf6a64&scoped=true&"
import script from "./SingleImage4.vue?vue&type=script&lang=js&"
export * from "./SingleImage4.vue?vue&type=script&lang=js&"
import style0 from "./SingleImage4.vue?vue&type=style&index=0&id=4fcf6a64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcf6a64",
  null
  
)

export default component.exports